import React from "react";

const ErrorPage = () => {
  return <h1>You have come to no man's land.</h1>;
};

export default ErrorPage;
